import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Nepali() {
  return (
    <ApiCommunityDirectoryPage
      community="Nepali"
      eyebrow="Nepali community guide"
      title="Nepali favorites, businesses, and local essentials in San Antonio."
      
      tags={["Nepali community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Nepali community guide?"
      modalIdPrefix="nepali-directory"
    />
  );
}
